import { render, staticRenderFns } from "./TemplateEditor.vue?vue&type=template&id=776e984b&"
import script from "./TemplateEditor.vue?vue&type=script&lang=ts&"
export * from "./TemplateEditor.vue?vue&type=script&lang=ts&"
import style0 from "./TemplateEditor.vue?vue&type=style&index=0&id=776e984b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports